import React from 'react';
import { Button, CardActions, IconButton } from '@mui/material';
import { DeleteOutline, EditOutlined, Visibility } from '@mui/icons-material';
import { PerkTemplate } from './models/PerkTemplate';
import { PerkTemplateCardBase } from './PerkTemplateCardBase';

interface PerkTemplateCardProps {
    template: PerkTemplate;
    onEdit?: (template: PerkTemplate) => void;
    onDelete?: (template: PerkTemplate) => void;
    suggested?: boolean;
}

export const PerkTemplateCard: React.FC<PerkTemplateCardProps> = ({
    template,
    onEdit,
    onDelete,
    suggested
}) => {
    const handleEdit = React.useCallback(() => {
        onEdit?.(template);
    }, [onEdit, template]);

    const handleDelete = React.useCallback(() => {
        onDelete?.(template);
    }, [onDelete, template]);

    return (
        <PerkTemplateCardBase template={template} suggested={suggested}>
            <CardActions sx={{ alignItems: 'center' }}>
                <Button
                    variant="text"
                    sx={{ flexGrow: 1, textTransform: 'none' }}
                    startIcon={suggested ? <Visibility /> : <EditOutlined />}
                    onClick={handleEdit}
                >
                    {suggested ? 'View template' : 'Edit template'}
                </Button>
                {!suggested && (
                    <IconButton size="small" onClick={handleDelete} aria-label="Delete template">
                        <DeleteOutline />
                    </IconButton>
                )}
            </CardActions>
        </PerkTemplateCardBase>
    );
};
